import { apiClient } from './client'

export type DocType = 'contract' | 'cnic' | 'offer_letter' | 'policy' | 'certificate' | 'other'
export type DocStatus = 'pending' | 'received' | 'verified'

export interface EmployeeDocument {
  id: string
  org_id: string
  user_id: string
  doc_type: DocType
  name: string
  document_url?: string | null
  expiry_date?: string | null
  status: DocStatus
  notes?: string | null
  uploaded_by?: string | null
  created_at: string
  updated_at: string
}

export interface DocumentInput {
  doc_type?: DocType
  name: string
  document_url?: string | null
  expiry_date?: string | null
  status?: DocStatus
  notes?: string | null
}

export async function listUserDocuments(userId: string): Promise<EmployeeDocument[]> {
  const res = await apiClient.get<EmployeeDocument[]>(`/documents/user/${userId}`)
  return res.data
}
export async function myDocuments(): Promise<EmployeeDocument[]> {
  const res = await apiClient.get<EmployeeDocument[]>('/documents/mine')
  return res.data
}
export async function createDocument(userId: string, data: DocumentInput): Promise<EmployeeDocument> {
  const res = await apiClient.post<EmployeeDocument>(`/documents/user/${userId}`, data)
  return res.data
}
export async function updateDocument(docId: string, data: Partial<DocumentInput>): Promise<EmployeeDocument> {
  const res = await apiClient.put<EmployeeDocument>(`/documents/${docId}`, data)
  return res.data
}
export async function deleteDocument(docId: string): Promise<void> {
  await apiClient.delete(`/documents/${docId}`)
}
